// apps/web/src/lib/compras/navegar.ts — Fase 13, Plano 22.
// O router escuta `popstate`; despachar o evento é a navegação programática sem reload (mesmo padrão das demais telas de Compras).
export function navegar(destino: string): void {
  window.history.pushState(null, '', destino);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
